import { Component, Input, OnInit} from '@angular/core';

import { LabOrder } from '../../shared/data/lab-order';

@Component({
  selector: 'app-advanced-lens',
  templateUrl: './advanced-lens.component.html',
  styleUrls: ['./advanced-lens.component.css']
})
export class AdvancedLensComponent implements OnInit {

  @Input() labOrder: LabOrder;

  constructor(
  ) { }

  ngOnInit(): void {
    // no web-services to call.
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/modify-order/advanced-lens/advanced-lens.component.ts